import countries from '@website/dataObjects/countries';
import { UserDashboardQuery } from '@website/types/graphqlOperations';
import { Col, Container, Row } from 'react-bootstrap';
import CardRoom from '../directoryTheme/CardRoom';

type JoinWishListButtonProps = {
  wishlist: UserDashboardQuery['user']['wishlist']['items'];
};

export default function UserWishlist({ wishlist }: JoinWishListButtonProps) {
  if (wishlist.length === 0) {
    return (
      <div className="text-center">
        <p className="text-muted">
          You currently have no trips in your Wishlist.
        </p>
      </div>
    );
  }

  return (
    <Container>
      <Row className="ps-1 pr-1">
        {wishlist.map((item) => (
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={4}
            className="px-2 py-1"
            data-cy="trip-card-col"
            key={item.id}
          >
            <CardRoom
              xs={12}
              sm={6}
              md={6}
              lg={4}
              data={{
                country: countries[item.trip.address.country],
                guestPrice: item.trip.minimumPrice,
                // we don't care about id, remainingSpaces, start here
                id: item.trip.id,
                remainingSpaces: 0,
                start: {} as any,
                trip: item.trip as any,
              }}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
